import { computed, ref } from '@vue/composition-api';
import provider from '@/api/apollo-client';
import useList from '../_basic/list';
import useItem from '../_basic/item';
import gqlItem from './item.graphql';
import gqlList from './list.graphql';

const schema = new useItem(gqlItem, false);
const schemas = new useList(gqlList, true);

export default function() {
  const showFields = ref([
    'name',
    'mAuthor',
    'mManufacturer',
    'mVersion',
    'mEmail',
    'enabled',
    'type',
    'parentSchemaName',
    'editorgroup',
    'usergroup',
    'readergroup'
  ]);
  function loadPureSchemata(type, filter = {}) {
    const variables = {
      orderBy: 'NAME_ASC',
      filter
    };
    if (type) {
      variables.filter = {
        ...filter,
        type: { equalTo: type }
      };
    }
    schemas.loading.value = true;
    return provider
      .query({
        query: gqlList.loadPure,
        variables
      })
      .then(r => {
        return r.data;
      })
      .finally(() => {
        schemas.loading.value = false;
      });
  }

  return {
    schema: {
      ...schema,
      addProperty: payload => {
        schema.loading.value = true;
        return provider
          .mutate({
            mutation: gqlItem.createSchemaProperty,
            variables: {
              input: {
                schemaProperty: payload
              }
            }
          })
          .finally(() => {
            schema.loading.value = false;
          });
      },
      addControl: (payload, id) => {
        schema.loading.value = true;
        return provider
          .mutate({
            mutation: gqlItem.createSchemaControl,
            variables: {
              input: {
                schemaControl: payload
              }
            }
          })
          .finally(() => {
            schema.loading.value = false;
          });
      },
      updateProperty: (id, patch) => {
        schema.loading.value = true;
        return provider.mutate({
          mutation: gqlItem.updateSchemaProperty,
          variables: {
            input: {
              id,
              patch
            }
          }
        });
      },
      updateControl: (id, patch) => {
        schema.loading.value = true;
        return provider
          .mutate({
            mutation: gqlItem.editSchemaControl,
            variables: {
              input: {
                id,
                patch
              }
            }
          })
          .finally(() => {
            schema.loading.value = false;
          });
      },
      updateSchema: (id, patch) => {
        schema.loading.value = true;
        return provider
          .mutate({
            mutation: gqlItem.updateSchema,
            variables: {
              input: {
                id,
                patch
              }
            }
          })
          .finally(() => {
            schema.loading.value = false;
          });
      },
      exportJson: id => {
        schema.loading.value = true;
        return provider
          .query({
            query: gqlItem.exportJson,
            fetchPolicy: 'network-only',
            nextFetchPolicy: 'network-only',
            variables: {
              schemaId: id
            }
          })
          .finally(() => {
            schema.loading.value = false;
          });
      },
      importJson: data => {
        return provider
          .mutate({
            mutation: gqlItem.importSchema,
            variables: {
              input: {
                jsonSchema: data
              }
            }
          })
          .finally(() => {
            schema.loading.value = false;
          });
      },
      bumpVersion: data => {
        return provider
          .mutate({
            mutation: gqlItem.bumpSchemaVersion,
            variables: {
              input: {
                schemas: data
              }
            }
          })
          .finally(() => {
            schema.loading.value = false;
          });
      },
      updateSchemas: data => {
        return provider
          .mutate({
            mutation: gqlList.updateSchemas,
            variables: {
              input: {
                mnPatch: data
              }
            }
          })
          .finally(() => {
            schema.loading.value = false;
          });
      },
      deleteSchemaProperty: id => {
        schema.loading.value = true;
        return provider
          .mutate({
            mutation: gqlItem.deleteSchemaProperty,
            variables: {
              input: {
                id
              }
            }
          })
          .finally(() => {
            schema.loading.value = false;
          });
      },
      getPropertyTypes: () => {
        schema.loading.value = true;
        return provider
          .query({
            query: gqlItem.getPropertyTypes
          })
          .finally(() => {
            schema.loading.value = false;
          });
      }
    },
    schemas: {
      ...schemas,
      loadPureSchemata,
      visibleFields: computed({
        get: () => {
          const sorted = showFields.value.map(i => {
            return schemas.visibleFields.value.find(e => e === i);
          });
          if (schemas.visibleFields.value.length) {
            return sorted;
          }
          return [];
        },
        set: arr => {
          showFields.value = arr;
          schemas.visibleFields.value = arr;
        }
      }),
      fields: computed(() => {
        const sorted = showFields.value.map(i => {
          return schemas.fields.value.find(e => e.key === i);
        });
        if (schemas.fields.value.length) {
          return sorted;
        }
        return [];
      })
    }
  };
}
